import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

console.warn("Material module loaded");

@NgModule({
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTabsModule,
    MatSortModule,
    MatDatepickerModule,
    MatListModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatExpansionModule,
    MatDividerModule,
    MatChipsModule,
    MatCardModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatStepperModule,
    MatMenuModule,
    MatSnackBarModule,
    MatCheckboxModule
  ],
  exports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTabsModule,
    MatSortModule,
    MatDatepickerModule,
    MatListModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatExpansionModule,
    MatDividerModule,
    MatChipsModule,
    MatCardModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatStepperModule,
    MatMenuModule,
    MatSnackBarModule,
    MatCheckboxModule
  ]
})

export class MaterialModule {
}
